export type SpinnerSize = "xs" | "sm" | "md" | "lg";
export type SpinnerTone = "brand" | "current" | "white" | "muted";

const SIZE: Record<SpinnerSize, string> = {
  xs: "h-3 w-3 border-2",
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-8 w-8 border-[3px]",
};

const TONE: Record<SpinnerTone, string> = {
  // Theme-aware Brand (Default) — flippt Light/Dark via .ds-spinner-accent (design-system/misc.css)
  brand: "ds-spinner-accent",
  // Erbt die Textfarbe — für Buttons / farbige Flächen (design-system/misc.css)
  current: "ds-spinner-current",
  // Für dunkle Overlays
  white: "border-white/40 border-t-white",
  // Neutral
  muted: "border-line-strong border-t-content-2",
};

export interface SpinnerProps {
  size?: SpinnerSize;
  tone?: SpinnerTone;
  className?: string;
  label?: string;
}

/**
 * Kanonischer Lade-Spinner (Ring). App-weit EINZIGER Spinner.
 * - In-Button / farbiger Grund: tone="current"
 * - Dunkles Overlay: tone="white"
 * - Sonst: Default tone="brand" (theme-aware)
 */
export function Spinner({ size = "sm", tone = "brand", className = "", label = "Lädt…" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block animate-spin rounded-full ${SIZE[size]} ${TONE[tone]} ${className}`}
    />
  );
}
